import { TIER_FEATURES, type SubscriptionTier } from './constants';
import styles from '../SubscriptionPage.module.css';

interface CurrentPlanCardProps {
  tier: string;
  dailyLimit: number;
  isExpired: boolean;
  endDate?: string;
}

export function CurrentPlanCard({ tier, dailyLimit, isExpired, endDate }: CurrentPlanCardProps) {
  const features = TIER_FEATURES[tier as SubscriptionTier] || TIER_FEATURES.Free;

  return (
    <div className={styles.currentPlanCard}>
      <h2 className={styles.currentPlanHeader}>Current Plan</h2>
      <div className={styles.currentPlanInfo}>
        <div>
          <p className={styles.currentPlanTier}>{tier} Plan</p>
          <p className={styles.currentPlanLimit}>{dailyLimit} solves per day</p>
        </div>
        {isExpired && (
          <span className={styles.expiredBadge}>
            Expired
          </span>
        )}
      </div>
      <ul className={styles.featureList}>
        {features.map((feature: string, idx: number) => (
          <li key={idx} className={styles.featureItem}>
            <svg className={styles.checkIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            {feature}
          </li>
        ))}
      </ul>
      {endDate && (
        <p className={styles.validUntil}>
          {isExpired ? 'Expired on' : 'Valid until'}: {new Date(endDate).toLocaleDateString()}
        </p>
      )}
    </div>
  );
}